import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { RenderKilogramo } from "Utils/renderField/renderReadField";
import { TIPOS_DETALLE_CIERRE_INVENTARIO_BODEGA } from "../../../../../utility/constants";
import NullableValue from "../../../Utils/renderField/nullableValue";

// Los kg llegan como string desde el backend y pueden venir vacíos, por eso se
// valida la ausencia del dato y no su valor
const aNumero = (valor) => {
    if (valor === "" || valor === null || valor === undefined) return 0;

    return Number(valor);
};

const CeldaKg = ({ valor, className = "" }) => (
    <td className={`text-right text-nowrap ${className}`}>
        <RenderKilogramo value={valor} decimalScale={2} />
    </td>
);

// Qué se contó: un pallet, que puede haber nacido del propio reajuste porque
// apareció físicamente sin estar registrado, o el sobrante del producto, que no
// tiene pallets
const EtiquetaPallet = ({ reajuste }) => {
    if (reajuste.tipo !== TIPOS_DETALLE_CIERRE_INVENTARIO_BODEGA.PACAS) {
        return <span className="text-muted">Sobrante</span>;
    }

    const identificacion =
        reajuste.pallet_numero ||
        reajuste.identificador_fisico ||
        "Sin identificar";

    if (!reajuste.pallet_creado) {
        return <span>{identificacion}</span>;
    }

    return (
        <span title="Pallet nuevo creado con este reajuste">
            {identificacion}
            <span className="text-muted"> (nuevo)</span>
        </span>
    );
};

// Historial de reajustes ya aplicados a la existencia. Se usa en su pestaña,
// con los datos del cierre que los aplicó, y dentro del detalle de un cierre,
// donde el cierre ya se conoce y esas columnas sobran
export const ReajustesInventarioTable = ({
    reajustes = [],
    mostrarCierre = true,
}) => {
    const columnas = mostrarCierre ? 10 : 8;

    return (
        <div className="new-table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        {mostrarCierre && <th>Fecha - hora de corte</th>}
                        {mostrarCierre && <th>No. de cierre</th>}
                        <th>Tipo de producto</th>
                        <th>Condición</th>
                        <th>Pallet</th>
                        <th>Antes</th>
                        <th>Después</th>
                        <th>Diferencia</th>
                        <th>Responsable</th>
                        <th>Observaciones</th>
                    </tr>
                </thead>
                <tbody>
                    {reajustes.length === 0 && (
                        <tr>
                            <td colSpan={columnas} className="text-center">
                                No hay reajustes de inventario registrados
                            </td>
                        </tr>
                    )}
                    {reajustes.map((reajuste) => {
                        const diferencia = aNumero(reajuste.diferencia_kg);

                        return (
                            <tr key={reajuste.id}>
                                {mostrarCierre && (
                                    <td className="text-center text-nowrap">
                                        {moment(reajuste.fecha_corte).format(
                                            "DD/MM/YYYY - HH:mm",
                                        )}
                                    </td>
                                )}
                                {mostrarCierre && (
                                    <td className="text-center text-nowrap">
                                        <Link
                                            to={`/produccion-bodega/inventario/cierre/${reajuste.cierre_id}`}
                                        >
                                            {reajuste.cierre_numero}
                                        </Link>
                                    </td>
                                )}
                                <td className="text-nowrap">
                                    {reajuste.producto_nombre}
                                </td>
                                <td className="text-nowrap">
                                    {reajuste.es_conforme_bodega
                                        ? "Conforme"
                                        : "No conforme"}
                                </td>
                                <td className="text-center text-nowrap">
                                    <EtiquetaPallet reajuste={reajuste} />
                                </td>
                                <CeldaKg
                                    valor={reajuste.kg_antes_del_reajuste}
                                />
                                <CeldaKg
                                    valor={reajuste.kg_despues_del_reajuste}
                                />
                                <CeldaKg
                                    valor={diferencia}
                                    className={
                                        diferencia !== 0 ? "text-danger" : ""
                                    }
                                />
                                <td className="text-center text-nowrap">
                                    {reajuste.usuario_nombre || "No definido"}
                                </td>
                                <td
                                    className={`${reajuste.observaciones ? "" : "text-center"}`}
                                >
                                    <NullableValue
                                        value={reajuste.observaciones}
                                    >
                                        {reajuste.observaciones || ""}
                                    </NullableValue>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
